<template>
  <BaseModal>
    <div class="sales-boost-content">
        <h3 class="sales-boost-header">Як збільшити онлайн продажі в Вашому закладі?</h3>
        <p>
            1. Розмістіть посилання на Ваше онлайн меню в соц. мережах:
        </p>
        <div class="menu-link-container">
             <img src="/icons/sales-menu-link.png" class="menu-link">
        </div>
        <p>
            2. Більше розповідайте про можливість замовлення в такий спосіб. 
        </p>
        <p>
            3. Намагайтесь максимально наповнити меню, особливо фотографії страв, адже як показує статистика, саме страви з фотографіями клієнти замовляють найчастіше. 
        </p>
        <p>
            4. Беріть участь у нашій системі лояльності та встановлюйте найбільш привабливий для гостя відсоток кешбеку.
        </p>
    </div>
    <div class="sales-boost-controls">
        <button class="round-button" @click="onClose">
            Зрозуміло
        </button>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/modals/BaseModal.vue'

export default {
    data() {
        return {

        }
    },
    methods: {
        onClose() {
            this.$emit('close');
        }
    },
    components: {
        BaseModal
    }
}
</script>

<style scoped>
.sales-boost-controls {
    display: flex;
    text-align: center;
    justify-content: center;

    margin-top: 2vh;
}

.menu-link {
    float: right;
}

.sales-boost-content {
    font-size: 1.9vh;
}

.menu-link-container {
    /* width: 100%; */
}

.sales-boost-header {
    font-size: 2.5vh;
    margin-bottom: 1vh;
}
</style>